<div aria-live="polite" class="message-container">
  @if (showDisclaimer$ | async) {
    <div class="english-disclaimer">
      <span
        ><lib-icon name="alert-triangle" size="x-small"></lib-icon> This webpage
        has been machine translated. If there are any uncertainties, please
        refer to the Swedish text.</span
      >
    </div>
  }
</div>
